import { Box, Button, Chip, Stack, TextField, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Ignore2240CompaniesService } from "../../../services/Ignore2240CompaniesService";
import { Ignore2240CompanyDTO } from "../../../types/Ignore2240CompanyDTO";
import { useUtils } from "../../../utils/utilFunctions";
import { useAlert } from "../../contextProviders/AlertProvider";

const Ignore2240Companies: FC = () => {
	const [cnpjs, setCnpjs] = useState<Ignore2240CompanyDTO[]>([]);
	const [newCnpj, setNewCnpj] = useState("");
	const { showAlert, showError } = useAlert();
	const { formatDocument } = useUtils();

	useEffect(() => {
		const load = async () => {
			const response = await new Ignore2240CompaniesService().listAll();
			if (response?.data) {
				const data: Ignore2240CompanyDTO[] = response.data;
				setCnpjs(data);
			} else {
				console.error('Erro ao buscar empresas que ignoram o 2240');
			}
		};
		load();
	}, []);

	return (
		<Box sx={{width: '100%', padding: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2}}>
			<Typography variant="h6">
				Insira o CNPJ de uma empresa para que a extração de eventos dela
				desconsidere a validação de eventos 2240 antes de 10/01/2022
			</Typography>
			<Stack
				direction="row"
				sx={{flexWrap: "wrap", display: cnpjs.length > 0 ? "flex" : "none", width: "100%", justifyContent: "center", gap: 1}}
			>
				{cnpjs && cnpjs.map((cnpj) => (
					<Chip
						key={cnpj.cnpj}
						label={cnpj.cnpj}
						onDelete={() => {
							deleteItem(cnpj.id);
						}}
					/>
				))}
			</Stack>
			<Box sx={{display: 'flex', gap: 2}}>
				<TextField
					value={newCnpj}
					onChange={(e) => setNewCnpj(formatDocument(e.target.value))}
					label="Adicionar CNPJ"
					sx={{width: "200px"}}
				/>
				<Button
					variant="contained"
					onClick={addItem}
					disabled={!newCnpj.length}
				>
					Adicionar
				</Button>
			</Box>
		</Box>
	);

	async function deleteItem(id: number) {
		const response = await new Ignore2240CompaniesService().remove(id);
		if (response?.status === 200) {
			setCnpjs(cnpjs.filter(cnpj => cnpj.id !== id));
			showAlert('CNPJ removido');
		} else {
			showError();
		}
	}

	async function addItem() {
		const newItem = { cnpj: newCnpj.trim() } as Ignore2240CompanyDTO;
		const response = await new Ignore2240CompaniesService()
			.addIgnoredCompany(newItem);
		if (response?.status === 201) {
			const addedCnpj: Ignore2240CompanyDTO = response.data;
			setCnpjs([...cnpjs, addedCnpj]);
			setNewCnpj("");
			showAlert('CNPJ adicionado');
		} else {
			showError();
		}
	}
};

export default Ignore2240Companies;